import { Payload } from 'recharts/types/component/DefaultLegendContent';

type RevenueBarChartHandlerProps = {
  selectedMonth: string | null;
  selectedLegend: string | null;
  setSelectedMonth: (month: string) => void;
  setSelectedLegend: (legend: string) => void;
};
export const getRevenueBarChartHandler = ({
  selectedMonth,
  selectedLegend,
  setSelectedMonth,
  setSelectedLegend,
}: RevenueBarChartHandlerProps): {
  handleLegendClick: (data: Payload) => void;
  handleBarClick: (yearmon: string) => void;
} => {
  const handleLegendClick = (data: Payload): void => {
    if (selectedLegend === data.dataKey) {
      setSelectedLegend('');
    } else {
      setSelectedLegend(data.dataKey as string);
    }
  };

  const handleBarClick = (yearmon: string): void => {
    if (selectedMonth) {
      setSelectedMonth('');
    } else {
      setSelectedMonth(yearmon);
    }
  };

  return {
    handleLegendClick,
    handleBarClick,
  };
};
